import React, { useEffect } from "react";
import CustomizeDialog from "components/Car/CustomizeDialog";
import { Grid, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import useApi from "_api/index";
import { formatCurrency2Digit } from "utils/helpers/format";
import AlertToast from "components/AlertToast";

const ModalSettingPrice = ({ open, onClose, car, onSuccess }) => {
  const [toast, setToast] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (!open) {
      formik.resetForm();
    }
    if (car && open) {
      formik.setFieldValue("sell_price", car?.sell_price ? car.sell_price : "");
    }
  }, [open, car]);

  const generateValidationSchema = () => {
    return Yup.object({
      sell_price: Yup.number()
        .typeError("กรุณากรอกราคาขายเป็นตัวเลข")
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .required("กรุณากรอกราคาขาย"),
    });
  };

  const formik = useFormik({
    initialValues: {
      sell_price: "",
    },
    validationSchema: generateValidationSchema(),
    onSubmit: (values) => {
      handleSettingPrice(values);
    },
  });

  const handleSettingPrice = async (values) => {
    try {
      const response = await useApi.ready_car.updateSellPriceCar(car.car_id, {
        sell_price: values.sell_price,
      });
      console.log("Response from setting price:", response);
      if (response.success) {
        onSuccess();
      } else {
        console.error("Failed to set price:", response.message);
        throw new Error(response.message);
      }
    } catch (error) {
      console.error("Error setting price:", error);
      setToast({
        open: true,
        message: "เกิดข้อผิดพลาดในการตั้งค่าราคาขาย",
        severity: "error",
      });
    }
  };

  return (
    <>
      <CustomizeDialog
        open={open}
        onClose={onClose}
        title="ตั้งค่าราคาขาย"
        fullWidth
        maxWidth="md"
        onSave={formik.handleSubmit}
        sx={{
          "& .MuiDialog-paper": {
            height: "300px",
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={2}
            sx={{ mt: 1, mb: 2, px: 1 }}
            alignItems="center"
          >
            <Grid item xs={12}>
              <Grid container alignItems="center" spacing={1}>
                <Grid
                  item
                  xs={2}
                  sx={{ alignItems: "center", display: "flex" }}
                >
                  ราคาขาย
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formik.values.sell_price}
                    name="sell_price"
                    onChange={(e) => {
                      let value = e.target.value;

                      // อนุญาตเฉพาะตัวเลขและจุด
                      if (!/^[0-9.]*$/.test(value)) return;

                      // อนุญาตให้มีจุดได้แค่ 1 จุด
                      const parts = value.split(".");
                      if (parts.length > 2) return;

                      // จำกัดทศนิยมไม่เกิน 2 หลัก
                      if (parts[1] && parts[1].length > 2) return;

                      // อัปเดตค่าใน formik
                      formik.setFieldValue("sell_price", value);
                    }}
                    onBlur={formik.handleBlur}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: "white",
                        height: "40px",
                      },
                    }}
                    type="number"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]*",
                      min: 0,
                    }}
                    placeholder="กรุณากรอกราคาขาย"
                    error={
                      formik.touched.sell_price &&
                      Boolean(formik.errors.sell_price)
                    }
                    helperText={
                      formik.touched.sell_price && formik.errors.sell_price
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </CustomizeDialog>
      <AlertToast
        open={toast.open}
        message={toast.message}
        type={toast.severity}
        onClose={() => setToast({ ...toast, open: false })}
      />
    </>
  );
};

export default ModalSettingPrice;
